// extracted by mini-css-extract-plugin
export default {"option":"vp_TJjS7","symbol":"vp_hTCEO","image":"vp_ZOoKx","label":"vp_LlCry","description":"vp_U9ZxA","clickable":"vp_OphvV","selected":"vp_QtLSa"};